import { useEffect, useState } from "react";
import { apiRequest } from "../api/client";
import AnimatedImage from "../components/AnimatedImage";
import Button from "../components/Button";
import SectionTitle from "../components/SectionTitle";
import { brand, coachStats, images } from "../data/siteData";

export default function About() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    apiRequest("/api/settings/public").then((response) => setSettings(response.data)).catch(() => {});
  }, []);

  const about = settings?.about_section || {};
  const stats = about.stats || coachStats;

  return (
    <section className="section about-page">
      <div className="container about-grid">
        <AnimatedImage src={images.coach} alt="Moataz Hafez posing in dramatic lighting" floating className="about-image" />
        <div className="about-copy">
          <SectionTitle align="left" eyebrow="Meet your coach" title="Moataz" highlight="Hafez" />
          <p>
            {(settings?.website_name || brand.name)} helps athletes and everyday lifters build stronger physiques through precise nutrition, disciplined training, and realistic systems.
          </p>
          <p>
            {about.text || "His mission is to remove confusion from fitness nutrition and give clients a clear blueprint they can follow with confidence."}
          </p>
          <div className="stats-row">
            {stats.map((stat) => (
              <div key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div>
          <div className="credential-list">
            <span>Bodybuilding nutrition coaching</span>
            <span>Transformation planning</span>
            <span>Performance-focused meal systems</span>
          </div>
          <Button to="/shop">Explore the eBook</Button>
        </div>
      </div>
    </section>
  );
}
